export const logoCoinBlackTransparent =
  "https://raw.githubusercontent.com/Axxeleum/mediapack/main/logo.png";
export const logoCoinRedTransparent =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/Logo%20-%20coin%20red%20transparent.png";
export const logoCoinWhiteTransparent =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/Logo%20-%20coin%20white%20transparent.png";
export const bgDark =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/Aera%20Branding%20Pack/Aerarium_Background_Nightmode-Compressed.jpg";
export const bgLight =
  "https://raw.githubusercontent.com/Axxeleum/mediapack/main/bg4.png";
export const iconsBalance =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/Aera%20Branding%20Pack/Icons/Aera_Balance.png";
export const iconBuilding =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/Aera%20Branding%20Pack/Icons/Aera_Building.png";
export const iconCoinpurse =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/Aera%20Branding%20Pack/Icons/Aera_Coinpurse.png";
export const iconCoins =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/Aera%20Branding%20Pack/Icons/Aera_Coins.png";
export const iconDown =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/Aera%20Branding%20Pack/Icons/Aera_Down.png";
export const iconHelmet =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/Aera%20Branding%20Pack/Icons/Aera_Helmet.png";
export const iconScroll =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/Aera%20Branding%20Pack/Icons/Aera_Scroll.png";
export const iconShield =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/Aera%20Branding%20Pack/Icons/Aera_Shield.png";
export const iconSwords =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/Aera%20Branding%20Pack/Icons/Aera_Swords.png";
export const iconTablet =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/Aera%20Branding%20Pack/Icons/Aera_Tablet.png";
export const iconUnbalance =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/Aera%20Branding%20Pack/Icons/Aera_UNbalance.png";
export const iconUp =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/Aera%20Branding%20Pack/Icons/Aera_Up.png";
export const tulipDAO =
  "https://raw.githubusercontent.com/aerariumfinance/media/main/TulipDao_secured_by.png";
